import type { FC, ReactNode } from 'react'

import { Skeleton } from '@skytech/ui'

import { useAppContext } from '@/App.context'

import './tabs.scss'

const LOADER_TABS_NUMBER = 6

type Tab = {
  children?: ReactNode
  selected?: boolean
  onClick?: () => void
}

export const DispatchTabs: FC<{ tabs: Tab[]; className?: string; isLoading: boolean }> = ({
  className,
  tabs,
  isLoading,
}) => {
  const { whiteLabel } = useAppContext()

  if (isLoading) {
    const skeletonArray = new Array(LOADER_TABS_NUMBER)
    skeletonArray.fill(null)

    return (
      <div className={`tabs ${Boolean(className) && className} wl-${whiteLabel}`}>
        {skeletonArray.map((_, index) => (
          <button disabled key={index}>
            <span>
              <Skeleton height="17px" width="100px" />
            </span>
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className={`tabs ${Boolean(className) && className} wl-${whiteLabel}`}>
      {tabs.map((tab, idx) => {
        const { onClick, selected = false, children } = tab

        return (
          <button key={idx} onClick={onClick} className={selected ? 'selected' : ''}>
            {children}
          </button>
        )
      })}
    </div>
  )
}
